export type Industry = {
  slug: string
  name: string
  need: string
  services: string[]
}

export const INDUSTRIES: Industry[] = [
  {
    slug: 'agroindustria',
    name: 'Agroindustria',
    need: 'Estacionalidad, protección de granos y control sanitario de instalaciones de almacenamiento.',
    services: ['Transporte & Distribución', 'Control de plagas y protección de granos', 'HSE & Seguridad', 'Parquización y poda en altura'],
  },
  {
    slug: 'logistica',
    name: 'Logística',
    need: 'Redes que crecen más rápido que la capacidad de coordinarlas y medirlas.',
    services: ['Consultoría de Supply Chain', 'Control Tower', 'Gestión de transportistas', 'KPIs y SLA'],
  },
  {
    slug: 'transporte',
    name: 'Transporte',
    need: 'Documentación de flota, choferes y unidades siempre vigente y verificable.',
    services: ['Control documental de flota', 'Monitoreo satelital multiplataforma', 'Auditorías a transportistas', 'Capacitaciones HSE'],
  },
  {
    slug: 'industria',
    name: 'Industria',
    need: 'Plantas que necesitan mantener producción, instalaciones y cumplimiento en paralelo.',
    services: ['Mantenimiento técnico preventivo y correctivo', 'Limpieza industrial', 'HSE & Seguridad', 'Logística interna'],
  },
  {
    slug: 'centros-de-distribucion',
    name: 'Centros de distribución',
    need: 'Picos de volumen, rotación de personal y control de cumplimiento en muelle.',
    services: ['Warehousing y almacenaje', 'Autoelevadores', 'Procesos y procedimientos', 'Control Tower'],
  },
  {
    slug: 'depositos',
    name: 'Depósitos',
    need: 'Espacio, seguridad e higiene bajo un mismo responsable.',
    services: ['Licitación de depósitos', 'Limpieza integral', 'Control de plagas', 'Mantenimiento de instalaciones'],
  },
  {
    slug: 'empresas-corporativas',
    name: 'Empresas corporativas',
    need: 'Múltiples proveedores para mantener oficinas y edificios operativos.',
    services: ['Facility Management integral', 'Limpieza corporativa', 'Mantenimiento técnico', 'Parquización'],
  },
  {
    slug: 'servicios',
    name: 'Servicios',
    need: 'Operaciones distribuidas con estándares que deben ser homogéneos.',
    services: ['Procesos y procedimientos', 'Capacitaciones', 'Reportes y dashboards', 'Evaluación de proveedores'],
  },
  {
    slug: 'produccion',
    name: 'Producción',
    need: 'Continuidad operativa: cada parada no planificada se paga en unidades producidas.',
    services: ['Mantenimiento preventivo', 'HSE & Seguridad', 'Abastecimiento y transporte', 'Mejora continua'],
  },
  {
    slug: 'comercio-exterior',
    name: 'Comercio exterior',
    need: 'Coordinación multimodal y documentación bajo control en cada tramo.',
    services: ['Operaciones multimodales', 'Operaciones internacionales cuando corresponda', 'Control documental', 'Control Tower'],
  },
]
